
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linking-agreement",
      function () {
        return require("private-next-pages/linking-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linking-agreement"])
      });
    }
  